import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'cccisd-react-router';
import style from './style.css';

import IconFacebook from 'cccisd-icons/facebook2';
import IconLinkedIn from 'cccisd-icons/linkedin';

import wpUrl from '../../helpers/wpUrl';

const CustomLink = props => {
    const { to } = props;

    if (typeof to === 'string' && /^http/.test(to)) {
        return <a href={to}>{props.children}</a>;
    }

    return <Link {...props}>{props.children}</Link>;
};

export default class Footer extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        showPolicyLinks: PropTypes.bool,
    };

    static defaultProps = {
        className: 'container',
        showPolicyLinks: true,
    };

    render() {
        return (
            <footer className={`${this.props.className} ${style.footer}`}>
                <div className={style.footerLeft}>
                    <nav>
                        <ul className={`list-unstyled ${style.mainNav}`}>
                            <li>
                                <CustomLink to={`${wpUrl}/about`}>About Us</CustomLink>
                            </li>
                            <li>
                                <CustomLink to={`${wpUrl}/#ServicesPort`}>Services</CustomLink>
                            </li>
                            <li>
                                <CustomLink to={`${wpUrl}/research`}>Research</CustomLink>
                            </li>
                            <li>
                                <CustomLink to="/products">Products</CustomLink>
                            </li>
                            <li>
                                <CustomLink to={`${wpUrl}/case-studies`}>Case Studies</CustomLink>
                            </li>
                            <li>
                                <CustomLink to={`${wpUrl}/3c-media-kit`}>Media Kit</CustomLink>
                            </li>
                        </ul>
                    </nav>
                    <p className="mb-0">
                        © Copyright 3C Institute, All Rights Reserved. P.O. Box 2037, Chapel Hill, NC 27515,&nbsp;
                        <span className="text-nowrap">(984) 316-0406</span>
                    </p>
                </div>

                <div className={style.footerRight}>
                    <ul className="list-unstyled list-inline">
                        <li className="list-inline-item">
                            <CustomLink to="https://www.facebook.com/3Cinstitute">
                                <IconFacebook />
                            </CustomLink>
                        </li>
                        <li className="list-inline-item">
                            <CustomLink to="https://www.linkedin.com/company/3cinstitute">
                                <IconLinkedIn />
                            </CustomLink>
                        </li>
                    </ul>
                    {this.props.showPolicyLinks && (
                        <ul className={'list-unstyled list-inline mb-0 ' + style.policyLinks}>
                            <li className="list-inline-item">
                                <CustomLink to={`${wpUrl}/terms-of-use`}>Terms of Use</CustomLink>
                            </li>
                            <li className="list-inline-item">
                                <CustomLink to={`${wpUrl}/privacy-policy`}>Privacy Policy</CustomLink>
                            </li>
                            <li className="list-inline-item">
                                <CustomLink to={`${wpUrl}/#ccc-lets-talk`}>Contact Us</CustomLink>
                            </li>
                        </ul>
                    )}
                </div>
            </footer>
        );
    }
}
